module.exports = __webpack_public_path__ + "img/access_pointer-1.9843eb0c.webp";